export default "__VITE_ASSET__Cs5tV_fk__"